import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { baseUrl } from '../../../../../../../core/constants/base-url';
import {productCardsWeeklyRatingsResourceType} from "../configs/pc-rating-modal-config";
import {RecordsDataRequestQueryParams, RecordTableParams} from "../../../../../../../core/types/records-table.types";
import {Observable} from "rxjs";
import {CalculateWeeklyRatingParams, ProductCardRatingWeekly} from "../types/pc-rating-modal.types";

@Injectable({
  providedIn: 'root'
})
export class PcRatingApiService {
  private http: HttpClient = inject(HttpClient);
  private weeklyUrl: string = `${baseUrl}/${productCardsWeeklyRatingsResourceType.path}`;

  public getWeeklyRating(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardRatingWeekly>> {
    return this.http.get<Array<ProductCardRatingWeekly>>(`${this.weeklyUrl}/calculations`, { params: queryParams });
  }

  public calculateWeeklyRating(calculateWeeklyRatingParams: CalculateWeeklyRatingParams): Observable<number> {
    return this.http.post<number>(`${this.weeklyUrl}/calculate`, calculateWeeklyRatingParams);
  }

  public getMeta(): Observable<RecordTableParams> {
    return this.http.get<RecordTableParams>(`${this.weeklyUrl}/meta`);
  }
}
